import { create } from "zustand";
import { persist } from "zustand/middleware";

const LOCAL_STORAGE_KEY = "SUPER_REAL";

export const DEFAULT_LOCAL_STORAGE: LocalStorage = {
  hasAcknowledgedAiDisclaimer: false,
};

export interface LocalStorage {
  hasAcknowledgedAiDisclaimer: boolean;
}

interface LocalStorageState {
  data: LocalStorage;
  setData: (next: Partial<LocalStorage>) => void;
}

export const useLocalStorage = create<LocalStorageState>()(
  persist(
    (set, get) => ({
      data: { ...DEFAULT_LOCAL_STORAGE },

      setData: (next) => {
        set({
          data: {
            ...DEFAULT_LOCAL_STORAGE,
            ...get().data,
            ...next,
          },
        });
      },
    }),
    {
      name: LOCAL_STORAGE_KEY,
      partialize: (state) => ({
        data: state.data,
      }),
    }
  )
);
